import type { CommonUserStats } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

export type EmployeesStatsTypes =
  | 'supervisors'
  | 'couriers'
  | 'operators'
  | 'assemblers'
  | 'brandManagers'

export interface EmployeesStatsQuery {
  stats: {
    [K in EmployeesStatsTypes]: CommonUserStats
  }
}

export interface EmployeesStatsQueryVariables {}

const GQL_QUERY_EMPLOYEES_STATS = gql`
  fragment statsFragment on SingleEmployeeStats {
    total
    active
    disabled
  }

  query {
    stats: employeesStats {
      supervisors {
        ...statsFragment
      }
      couriers {
        ...statsFragment
      }
      operators {
        ...statsFragment
      }
      assemblers {
        ...statsFragment
      }
      brandManagers {
        ...statsFragment
      }
    }
  }
`

export const useFetchEmployeesStats = () =>
  useQuery<EmployeesStatsQuery, EmployeesStatsQueryVariables>(
    GQL_QUERY_EMPLOYEES_STATS
  )
